import { apiMipe } from '@/core/api/';
import qs from "querystring";

export const getValidationMessages = async (messageCodes) => {
  try {
    const { data } = await apiMipe.get('/api/validationsMessages', {
      params: { messageCodes: messageCodes + '' },
    });
    return data;
  } catch (error) {
    return [];
  }
};

export const getSysParamById = (id) => {
  return apiMipe.get(`/api/sysparameter/sysparameter?sysParameterId=${id}`);
};

export const getSysParamByName = async (params) => {
  return await apiMipe.get(`/api/sysparameter/byparameternames`, {
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
  });
};
